import React, { useState, memo } from "react";
import { Tooltip, IconButton } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import ImportExportIcon from "@mui/icons-material/ImportExport";
import moment from "moment-jalaali";
import Api from "../../utils/api";
import ExcelJS from "exceljs";

const ProductExcelDownload = ({ object }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        const params = { ...object, excel_export: 1 };

        try {
            const response = await new Api().get("/products", params);
            if (response && response.length) {
                const data = response.map((product) => ({
                    "شناسه محصول": product.id,
                    "نام محصول": product.title,
                    "کد انبار": product.code,
                    "برند": product.brand?.title || "-",
                    "موجودی": product.types?.[0]?.count || 0,
                    "وزن": product.types?.[0]?.weight || 0,
                    "واحد": product.package_type?.title || "-",
                    "قیمت": product.types?.[0]?.price || 0,
                    "تخفیف": product.types?.[0]?.discount || 0,
                    "وضعیت": product.status ? "فعال" : "غیرفعال",
                }));

                await exportToExcel(data);
            }
        } catch (err) {
            console.error("خطا در دریافت محصولات:", err);
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Products");

        worksheet.columns = Object.keys(data[0]).map((key) => ({
            header: key,
            key,
            width: 20,
        }));

        data.forEach((row) => worksheet.addRow(row));

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `products_${moment().unix()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <Tooltip title="خروجی اکسل">
      <span>
        <IconButton onClick={fetchData} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : <ImportExportIcon />}
        </IconButton>
      </span>
        </Tooltip>
    );
};

export default memo(ProductExcelDownload);
